import { SectionWrapper } from './Section.styled';

export default function Section({ children }) {
  return <SectionWrapper>{children}</SectionWrapper>;
}
